let cachedFrogoId: string | undefined;

export const useFrogoFingerprintId = async (): Promise<string | undefined> => {
  if (cachedFrogoId !== undefined) return cachedFrogoId;

  if (typeof window.aftSID !== 'function') return undefined;

  cachedFrogoId = await window.aftSID();
  return cachedFrogoId;
};
